import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Layout
const DashboardLayout = lazy(() => import('./components/layout/DashboardLayout'));

// Website pages
const Landing = lazy(() => import('./website/Landing'));
const PrivacyPolicy = lazy(() => import('./website/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./website/TermsOfService'));
const FAQ = lazy(() => import('./website/FAQ'));
const ContactUs = lazy(() => import('./website/ContactUs'));

// Auth pages
const Login = lazy(() => import('./pages/auth/Login'));
const Register = lazy(() => import('./pages/auth/Register'));
const ForgotPassword = lazy(() => import('./pages/auth/ForgotPassword'));
const ResetPassword = lazy(() => import('./pages/auth/ResetPassword'));

// App/Dashboard pages
const Dashboard = lazy(() => import('./pages/app/Dashboard'));
const CashIn = lazy(() => import('./pages/app/CashIn'));
const Transactions = lazy(() => import('./pages/app/Transactions'));
const Profile = lazy(() => import('./pages/app/Profile'));
const Referrals = lazy(() => import('./pages/app/Referrals'));
const Wallets = lazy(() => import('./pages/app/Wallets'));
const Withdraw = lazy(() => import('./pages/app/Withdraw'));
const KYC = lazy(() => import('./pages/app/kyc/KYC'));
const KYCSubmitted = lazy(() => import('./pages/app/kyc/KYCSubmitted'));
const KYCApproved = lazy(() => import('./pages/app/kyc/KYCApproved'));

// Admin routes
const AdminRoutes = lazy(() => import('./admin/routes/AdminRoutes'));

function App() {
  return (
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<ContactUs />} />

          {/* Auth Routes - No Layout */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/register/:referralCode" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* App/Dashboard Routes - With Layout */}
          <Route path="/app" element={<DashboardLayout />}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="cash-in" element={<CashIn />} />
            <Route path="transactions" element={<Transactions />} />
            <Route path="profile" element={<Profile />} />
            <Route path="referrals" element={<Referrals />} />
            <Route path="wallets" element={<Wallets />} />
            <Route path="withdraw" element={<Withdraw />} />
            <Route path="kyc" element={<KYC />} />
            <Route path="kyc/submitted" element={<KYCSubmitted />} />
            <Route path="kyc/approved" element={<KYCApproved />} />
          </Route>

          {/* Admin Routes */}
          <Route path="/admin/*" element={<AdminRoutes />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
